<template>
    <div>
        <div class="ui fluid input" v-if="is_initialized">
            <input type="tel"
                :ref="related_column.name"
                :placeholder="(related_column.is_required)
                    ? $t('ui.scanner.alerts.required_field')
                    : $t('ui.scanner.alerts.if_have_write')
                "
                @keypress.enter="$bus.$emit('scanner_next_actions_core_waybill_related')"
                v-model="actions_core_waybill_related_columns[related_column.name]">
        </div>
    </div>

</template>

<script>
export default {
    components: {
    },
    props: {
        related_column: {
            default: {},
            input_type: Object
        },
        focus_input_name: {
            default: "",
            input_type: String
        },
        is_inverted: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.customer.scanner_module
        },
        actions_core_waybill_related_columns() {
            return this.current_store.actions_core_waybill_related_columns
        },
    },
    watch: {
        related_column() {
            this.init()
        },
        focus_input_name: {
            handler(value, oldVal) {
                this.focus_input()
            },
            deep: true
        },
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            try {
                await new Promise(resolve => {
                    this.is_initialized = true
                    resolve()
                })
                await this.focus_input()
            } catch (e) {
                console.log(e)
            }
        },
        focus_input() {
            try {
                if (!this.focus_input_name)
                    throw 'no focus_input_name'

                if (!this.related_column.name)
                    throw 'no related_column.name'

                if (this.focus_input_name === this.related_column.name) {
                    setTimeout(() => {
                        this.$refs[this.related_column.name].focus()
                    }, 300)
                } else {
                    this.$refs[this.related_column.name].blur()
                }
            } catch (e) {
                console.log(e)
            }

            return Promise.resolve()
        },
    },

}
</script>

<style lang="scss" scoped>
    .center.aligned {
        text-align: center;
    }
    .left.aligned {
        text-align: left;
    }
    .right.aligned {
        text-align: right;
    }

    .file_uploader_tool {
        & {
            display: inline-block;
            border-radius: 4px;
            background: #ffffff !important;
        }
        // .ui.basic.button {
        //     color: white !important;
        // }
        // .ui.basic.button:hover {
        //     background: #1b1c1d !important;
        // }
    }

    .file_uploader_message {
        & {
            margin: 0;
            text-align: right;
        }
        .failure {
            color: red;
        }
        .success {
            color: #21ba45;
        }
    }

    #core_waybill_related_columns_alert {
        & {
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
            z-index: 2;
            background-color: rgba(27, 28, 29, 0.8);
        }
        .segment {
            width: 50%;
            top: 25%;
            margin: 0 auto;
        }
    }


    @media only screen and (max-width: 767px) {
        #core_waybill_related_columns_alert {
            .segment {
                width: 100%;
            }
        }
    }

    @media only screen and (min-width: 767px) {

    }
</style>
